module.exports = __webpack_public_path__ + "img/features-bg_15.436ef7c6.png";